var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '../../di/injectable';
import DOMClasslist from './classlist';
var DOMUtils = /** @class */ (function (_super) {
    __extends(DOMUtils, _super);
    function DOMUtils() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusableElementSelector = 'button, a, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
        return _this;
    }
    DOMUtils.prototype.getFocusableElements = function (element) {
        var focusableElements = this.getElements(this.focusableElementSelector, element);
        return focusableElements;
    };
    DOMUtils.prototype.getFocusableElement = function (element) {
        return this.getElement(this.focusableElementSelector, element);
    };
    DOMUtils.prototype.getElement = function (selector, wrapper) {
        if (wrapper === void 0) { wrapper = document.body; }
        return wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(selector);
    };
    DOMUtils.prototype.getElements = function (selector, wrapper) {
        if (wrapper === void 0) { wrapper = document.body; }
        return this.convertToArray(wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelectorAll(selector));
    };
    DOMUtils.prototype.getElementById = function (id) {
        return document.getElementById(id);
    };
    DOMUtils.prototype.getElementsByClassName = function (className, wrapper) {
        if (wrapper === void 0) { wrapper = document.body; }
        return this.convertToArray(wrapper === null || wrapper === void 0 ? void 0 : wrapper.getElementsByClassName(className));
    };
    DOMUtils.prototype.getElementByClassName = function (className, wrapper) {
        if (wrapper === void 0) { wrapper = document.body; }
        return this.getElementsByClassName(className, wrapper)[0];
    };
    DOMUtils.prototype.closest = function (className, wrapper) {
        return wrapper === null || wrapper === void 0 ? void 0 : wrapper.closest(className);
    };
    DOMUtils.prototype.convertToArray = function (elements) {
        if (elements == null) {
            return [];
        }
        return Array.prototype.slice.call(elements);
    };
    DOMUtils.prototype.htmlIterator = function (element, key, selector) {
        var nextElements = [];
        var nextElement = element;
        while (nextElement[key]) {
            nextElement = nextElement[key];
            if (!selector) {
                nextElements.push(nextElement);
            }
            else if (nextElement.matches(selector)) {
                nextElements.push(nextElement);
            }
        }
        return nextElements;
    };
    DOMUtils.prototype.nextAll = function (element, selector) {
        return this.htmlIterator(element, 'nextElementSibling', selector);
    };
    DOMUtils.prototype.prevAll = function (element, selector) {
        if (selector === void 0) { selector = null; }
        return this.htmlIterator(element, 'previousElementSibling', selector);
    };
    DOMUtils.prototype.parents = function (element, selector) {
        return this.htmlIterator(element, 'parentElement', selector);
    };
    DOMUtils.prototype.offsetTop = function (target) {
        return (target instanceof HTMLElement ? target.getBoundingClientRect() : target).top + window.pageYOffset;
    };
    DOMUtils = __decorate([
        Injectable()
    ], DOMUtils);
    return DOMUtils;
}(DOMClasslist));
export { DOMUtils };
//# sourceMappingURL=index.js.map